<template>
  <a
    :href="attachment.object.viewCampaignUrl"
    target="_blank"
  >
    <AttachmentEmbedContainer
      :title="attachment.object.campaign.preview || attachment.object.campaign.subject"
      :type="`${attachment.object.campaign.typeLabel} Campaign `"
      :info="$date.format(attachment.object.sent * 1000, $date.presets.short)"
      icon="marketing"
    />
  </a>
</template>

<script setup lang="ts">
import AttachmentEmbedContainer from '../../embed/Container.vue'

interface Props {
  attachment: Record<string, any>
}

defineProps<Props>()
</script>
